<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    // 加载Font Awesome 6
    const fontAwesomeLink = document.createElement('link');
    fontAwesomeLink.rel = 'stylesheet';
    fontAwesomeLink.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css';
    document.head.appendChild(fontAwesomeLink);
    
    // 加载AOS动画库
    const aosScript = document.createElement('script');
    aosScript.src = 'https://unpkg.com/aos@2.3.1/dist/aos.js';
    document.head.appendChild(aosScript);
    
    const aosLink = document.createElement('link');
    aosLink.rel = 'stylesheet';
    aosLink.href = 'https://unpkg.com/aos@2.3.1/dist/aos.css';
    document.head.appendChild(aosLink);
    
    // 初始化AOS
    aosScript.onload = function() {
      if (typeof AOS !== 'undefined') {
        AOS.init();
      }
    };
  }
}
</script>

<style>
:root {
  --primary-color: #175480;
  --secondary-color: #99C33C;
  --accent-color: #f8f9fa;
  --text-color: #333333;
  --light-bg: #f8f9fa;
  --border-color: #dee2e6;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', sans-serif;
  line-height: 1.6;
  color: var(--text-color);
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.disabled {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.6;
}
</style> 